import {BusinessTransactionItemKey} from './business-transaction-itemkey';

export class BusinessTransactionValidationRequest {
    public businessTransactionTypeId: number;
    public businesstransactionValidationMode: number;
    public itemKeys: BusinessTransactionItemKey[] = [new BusinessTransactionItemKey(), new BusinessTransactionItemKey()];
    public businessTransactionId = 0;
    public businessTransactionAreaId: number;
    public details: any;
    public validationResults: any[];

    constructor() {}

    get customerKey(): BusinessTransactionItemKey {
        return this.itemKeys[0];
    }

    set customerKey(itemKey: BusinessTransactionItemKey) {
        this.updateKey(0, itemKey.itemKeyId, itemKey.businessTransactionItemKeyTypeId);
    }

    get vehicleKey(): BusinessTransactionItemKey {
        return this.itemKeys[1];
    }

    set vehicleKey(itemKey: BusinessTransactionItemKey) {
        this.updateKey(1, itemKey.itemKeyId, itemKey.businessTransactionItemKeyTypeId);
    }

    updateKey(index: number, itemKeyId: number, businessTransactionItemKeyTypeId: number) {
        if (index > this.itemKeys.length) {
            return;
        }

        this.itemKeys[index].itemKeyId = itemKeyId;
        this.itemKeys[index].businessTransactionItemKeyTypeId = businessTransactionItemKeyTypeId;
    }
}
